var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSchoolBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M777.483 180.154H613.131V162.679C613.131 114.95 574.299 76.1133 526.566 76.1133H273.434C225.701 76.1133 186.869 114.946 186.869 162.679V180.154H22.5172C10.101 180.154 0 190.255 0 202.671V277.499L165.196 417.103C168.63 410.857 175.196 406.57 182.828 406.57H237.374C248.529 406.57 257.576 415.616 257.576 426.772V439.754H542.424V426.772C542.424 415.616 551.471 406.57 562.626 406.57H617.172C624.804 406.57 631.37 410.853 634.804 417.103L800 277.499V202.671C800 190.255 789.899 180.154 777.483 180.154ZM227.273 162.679C227.273 137.224 247.98 116.517 273.434 116.517H526.562C552.016 116.517 572.723 137.224 572.723 162.679V180.154H227.269L227.273 162.679ZM637.374 467.83L778.857 348.267V665.948C778.857 697.895 752.865 723.883 720.921 723.883H79.0828C47.1354 723.883 21.1475 697.891 21.1475 665.948V348.267L162.63 467.83V513.135C162.63 524.291 171.677 533.338 182.832 533.338H237.378C248.533 533.338 257.58 524.291 257.58 513.135V480.158H542.428V513.135C542.428 524.291 551.475 533.338 562.63 533.338H617.176C628.331 533.338 637.378 524.291 637.378 513.135V467.83H637.374Z",
    fill: "#062134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSchoolBag);
export default __webpack_public_path__ + "static/media/ico_school_bag.4f9636a07d63b6cbd41ed347c75f2b1d.svg";
export { ForwardRef as ReactComponent };